import styled from "styled-components";
import {  useContext, useEffect } from "react";
import RegulamentDescript from "./CadastroDescript/RegulamentDescript";
import { PageContext } from "../../Context/PageContext";
import DoramChibiImg from "./img/doram_female_hair1_color1.gif"
import { TipMouseOutEvent, TipMouseOverEvent } from "../../Tooltip/Tooltip";
import { WavSoundEffect } from "../../WavSoundEffects/WavSoundEffects";

function Cadastro(){

    const { registerPageSection } = useContext(PageContext)

        useEffect(() => {setTimeout(() => {  document.getElementById("CadastroContainer").style.opacity = 1}, 200)
    },[])

    return(
    <CadastroContainer id="CadastroContainer">
        <TitleContainer>
            <Title>Cadastro e Controle de Conta</Title>
            <T1>
                <span>Ainda não tem conta? Cadastre-se agora mesmo e mergulhe nesse mundo de aventuras!</span><br/>
                <span><b>IMPORTANTE:</b> Não se esqueça de ler as regras e termos do nosso servidor. Ao criar uma nova conta, você concorda e aceita todos os termos de uso e conduta estabelecidos para acesso e permanência da conta.
                </span>
            </T1>

            <DoramChibi
                bgImg={DoramChibiImg}
                onMouseOver={(event) => TipMouseOverEvent(event, "Quase lá!<br> (não clique!) ♪",  "(0,0,0,1)")}
                onMouseLeave={() => TipMouseOutEvent() }
                onClick={() =>  WavSoundEffect(' ', '/bgm/169.mp3', 'click')}/>
        </TitleContainer>

        <MiddleContainer>
            {registerPageSection}
        </MiddleContainer>

    </CadastroContainer>
    );
};

const CadastroContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
    transition: 2s;
    margin-bottom: 50px;
    
    @media (max-width: 1000px) {
    width: 90vw;
    }
    opacity: 0;
`;

const ColumnA = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 1000px) {
    width: 90vw;
    }
`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1000px;

    @media (max-width: 1000px) {
    width: 90vw;
    text-align: justify;
    margin-bottom: 0px;
    }
`;

const Title = styled.h1`
    font-size: 30pt;

    @media (max-width: 1000px) {
    font-size: 24pt;
    text-align: center;
    }
`;

const T1 = styled.div`
    text-align: center;

    @media (max-width: 1000px) {
    text-align: justify;
    overflow: auto;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 black;
    }
`;

const DoramChibi = styled.div`
    background-image: url(${props => props.bgImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 80px;
    height: 130px;
    margin-top: 50px;
    //border: solid 2px black;
    
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

    @media (max-width: 1000px) {
    scale: 1.3;
    }
`

const MiddleContainer = styled.div`
    display: flex;
    flex-direction: line;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;

    @media (max-width: 1200px) {
    width: 90vw;
    flex-direction: column;
    align-items: center;
    }
`;

export default Cadastro;